import * as style from '../../utils/general_style.js';
import bgImage from '../../assets/demande_un_devis.jpg';
import CTAButton from './CTAButton.jsx';

function CTABar() {
    const divStyle = {
        ...style.COLUMN_CENTER,
        width: '100%',
        height: '100px',
        zIndex: '999',
        backgroundImage: `url(${bgImage})`
    };

	return (
        <div className="cta-bar" style={{...divStyle, position:'sticky', bottom:'0'}}>
            <div style={{...divStyle, backgroundImage: `linear-gradient(90deg, ${style.COLORS.primary_trans}, ${style.COLORS.secondary_trans})`}}>
                <CTAButton />
            </div>
        </div>
	);
};

export default CTABar;